import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

const SystemOptions = (props: { systemFormPayload: UseFormPayload }) => {
  const { systemFormPayload } = props

  const {
    entityState: {
      options,
    },
    handlers,
  } = systemFormPayload

  const {
    accounting_platform_api,
    ofi_submissions,
    reaxml_parser,
    xero_integration,
  } = options || {}

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column', padding: 'large' }} title="Options">
      <Form.Row>
        <Form.Field label="OFI Submissions">
          {/*
           // @ts-expect-error TS2322 */}
          <select name="options.ofi_submissions" value={ofi_submissions} {...handlers}>
            <option value="">Please Select...</option>
            <option value="legacy">Legacy (Default)</option>
            <option value="V2">V2</option>
          </select>
        </Form.Field>

        {/*
         // @ts-expect-error TS2322 */}
        <Form.Field label="REAXML Parser" marginTop={['large', 0]}>
          {/*
           // @ts-expect-error TS2322 */}
          <select name="options.reaxml_parser" value={reaxml_parser} {...handlers}>
            <option value="">Please Select...</option>
            <option value="legacy">Legacy (Default)</option>
            <option value="V2">V2</option>
          </select>
        </Form.Field>
      </Form.Row>

      <Form.Row marginTop="large">
        <Form.Field label="Accounting Platform">
          {/*
           // @ts-expect-error TS2322 */}
          <select name="options.accounting_platform_api" value={accounting_platform_api} {...handlers}>
            <option value="">Please Select...</option>
            <option value="xero">Xero</option>
            <option value="myob_advanced">MYOB Advanced</option>
          </select>
        </Form.Field>

        {accounting_platform_api !== 'myob_advanced' && (
          // @ts-expect-error TS2322
          <Form.Field label="Xero" marginTop={['large', 0]}>
            {/*
             // @ts-expect-error TS2322 */}
            <select name="options.xero_integration" value={xero_integration} {...handlers}>
              <option value="">Please Select...</option>
              <option value="V2">V2</option>
            </select>
          </Form.Field>
        )}
      </Form.Row>
    </DashboardModule>
  )
}

export default SystemOptions
